import { Card } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { AppBar, Drawer } from "../../../../components";
import "./style";
import styles from "./styleModule";

const FairRulesPopup = ({ onClose = () => {}, visible = false, destroyOnClose = false, data }) => {
  const { t } = useTranslation();
  const renderContent = () => {
    return (
      <div className={`${styles.rulePopupContainer} rule-popup-container`}>
        <AppBar
          title={data?.title}
          showBackButton={true}
          iconClosePadding={"4px"}
          onClickEvent={() => {
            onClose();
          }}
        />
        <div className={styles.container}>
          <Card title={data?.subTitle} className={styles.card}>
            <div dangerouslySetInnerHTML={{ __html: data?.content }} />
          </Card>
        </div>
      </div>
    );
  };

  return (
    <>
      <Drawer
        placement={"right"}
        isClosable={false}
        onClose={onClose}
        showDrawer={visible}
        destroyOnClose={destroyOnClose}
        width={"100%"}
        renderContent={renderContent}
      />
    </>
  );
};

export default FairRulesPopup;
